import * as types from './types';

export const setCandidateReferencesLoading = (isLoading) => ({
    type: types.CANDIDATE_REFERENCES_SET_LOADING,
    isLoading
});

export const getCandidateReferences = () => ({
    type: types.CANDIDATE_REFERENCES_GET_REFERENCES
});

export const setCandidateReferences = (candidateReferences) => ({
    type: types.CANDIDATE_REFERENCES_SET_REFERENCES,
    candidateReferences
});

export const setDisplayNewCandidateReferenceRequestForm = (display) => ({
    type: types.CANDIDATE_REFERENCES_SET_DISPLAY_NEW_REQUEST_FORM,
    display
});

export const setCandidateReferencesLimitReached = (reached) => ({
    type: types.CANDIDATE_REFERENCES_SET_COUNT_LIMIT_REACHED,
    reached
});

export const resetCandidateReferences = () => ({
    type: types.CANDIDATE_REFERENCES_RESET
});

export const submitNewCandidateReferenceRequest = (request, onSuccess) => ({
    type: types.CANDIDATE_REFERENCES_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST,
    request,
    onSuccess
})

export const resendCandidateReferenceNotification = (candidateReferenceId) => ({
    type: types.CANDIDATE_REFERENCES_RESEND_NOTIFICATION,
    candidateReferenceId
})

export const removeCandidateReference = (candidateReferenceId, onSuccess) => ({
    type: types.CANDIDATE_REFERENCES_REMOVE_CANDIDATE_REFERENCES,
    candidateReferenceId,
    onSuccess
})

export const setNotEnoughReferencesToApply = (enough) => ({
    type: types.CANDIDATE_REFERENCES_SET_NOT_ENOUGH_REFERENCES_TO_APPLY,
    enough
})

export const setSubmitNewCandidateReferenceRequestError = (error) => ({
    type: types.CANDIDATE_REFERENCES_SET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR,
    error
})

export const resetSubmitNewCandidateReferenceRequestError = () => ({
    type: types.CANDIDATE_REFERENCES_RESET_SUBMIT_NEW_CANDIDATE_REFERENCE_REQUEST_ERROR
})




// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-references/index.js